import { debounce } from 'throttle-debounce';
import isDesktopUa from 'is-desktop-ua';
import Module from './Module';

export default class ModuleHero extends Module {
	constructor(el) {
		super(el);
	}

	// -- Methods
	//--------------------------------------------------------------
	init() {
		$.extend(this.dom, {
			container: this.dom.el.find('.container'),
			sources: this.dom.el.find('.hero__video source'),
			video: this.dom.el.find('.hero__video video'),
		});

		this.img = {
			desktop: this.dom.container.data('img-desktop'),
			mobile: this.dom.container.data('img-mobile'),
		};

		let img = this.img.desktop;
		if (window.deviceSize === 'xs') {
			img = this.img.mobile;
		}

		const videos = this.dom.video[0];

		// this.loadBackground(img, videos);
		this.bindEvents();
	}

	bindEvents() {
		let width = this.dom.w.width();

		// resize X only
		this.dom.w.on(
			'resize',
			debounce(300, () => {
				const newWidth = this.dom.w.width();

				if (width !== newWidth) {
					this.setBackgroundVideo();
				}

				// reset the basic width
				width = this.dom.w.width();
			})
		);
	}

	loadBackground(img, videos) {
		const compatibleDevices = {
			desktop: isDesktopUa(navigator.userAgent),
			android: {
				name: ua.os.name === 'Android',
				version: parseFloat(ua.os.version) >= 6,
			},
			ios: {
				name: ua.os.name === 'iOS',
				version: parseFloat(ua.os.version) >= 10,
			},
			browser: {
				chrome: {
					name: ua.browser.name === 'chrome',
					version: parseFloat(ua.browser.version) >= 54,
				},
				safari: {
					name: ua.browser.name === 'safari',
					version: parseFloat(ua.browser.version) >= 10,
				},
			},
		};

		if (videos) {
			if (
				compatibleDevices.desktop ||
				(compatibleDevices.android.name &&
					compatibleDevices.android.version &&
					compatibleDevices.browser.chrome &&
					compatibleDevices.browser.chrome.version) ||
				(compatibleDevices.ios.name &&
					compatibleDevices.ios.version &&
					(compatibleDevices.browser.safari.version ||
						compatibleDevices.browser.chrome.version))
			) {
				this.setBackgroundVideo();
				this.dom.video.load();

				this.dom.video[0].addEventListener('loadeddata', () => {
					// try 0 or 2
					if (this.dom.video[0].readyState >= 2) {
						this.dom.el.addClass('loaded');
						this.dom.body.addClass('hero-loaded');
					}
				});
			} else {
				const moduleImageSrc = this.dom.el.find('[data-module=ImageSrc]');
				moduleImageSrc.attr('data-video-background', 'false');

				this.dom.el.addClass('loaded');
				this.dom.body.addClass('hero-loaded');
			}
		} else if (img) {
			$('<img/>')
				.attr('src', img)
				.load(() => {
					this.dom.el.addClass('loaded');
					this.dom.body.addClass('hero-loaded');
				});
		} else {
			this.dom.el.addClass('loaded');
			this.dom.body.addClass('hero-loaded');
		}
	}

	setBackgroundVideo() {
		// load one time only if is on the other size
		if (
			window.deviceSize === 'md' ||
			window.deviceSize === 'lg' ||
			window.deviceSize === 'xl'
		) {
			[].forEach.call(this.dom.sources, (source) => {
				const currentSrc = source.getAttribute('src');
				const dataVideoSrc = source.getAttribute('data-video-desktop');

				if (currentSrc !== dataVideoSrc) {
					source.src = dataVideoSrc;
					this.dom.video.load();
				}
			});
		} else {
			[].forEach.call(this.dom.sources, (source) => {
				const currentSrc = source.getAttribute('src');
				const dataVideoSrc = source.getAttribute('data-video-mobile');

				if (currentSrc !== dataVideoSrc) {
					source.src = dataVideoSrc;
					this.dom.video.load();
				}
			});
		}
	}
}
